import React from 'react';
import { FolderOpenIcon } from '@heroicons/react/24/outline';
import Button from './Button';

export default function EmptyState({
  icon: Icon = FolderOpenIcon,
  title,
  description,
  action,
  actionLabel,
  className = ''
}) {
  return (
    <div className={`empty-state ${className}`}>
      <Icon className="empty-state-icon" />
      <h3 className="empty-state-title">{title}</h3>
      {description && (
        <p className="empty-state-description">{description}</p>
      )}
      {action && actionLabel && (
        <Button onClick={action}>{actionLabel}</Button>
      )}
    </div>
  );
}
